export default __webpack_public_path__ + "88c66847acf5e5786f70ec364d816a58.png";